<template>
  <div class="item-container">
    <div class="sender col-md-3">
      <p>
        <strong>Société</strong> : <span v-if="message.company">{{message.company}}</span>
        <br>
        <strong>Identité</strong> : <span v-if="message.contact">{{message.contact}}</span>
        <br>
        <strong>Email</strong> : <span v-if="message.email">{{message.email}}</span>
        <br>
        <strong>Téléphone</strong> : <span v-if="message.phone">{{message.phone}}</span>
      </p>
    </div>
    <div :class="message_style">
      <div class="message">
        <p v-if="message.message">
          {{message.message}}
        </p>
        <p v-else>
          Pas de message.
        </p>
      </div>
      <div class="forwarder ">
        <span v-if="message.calling_date">Date et heure de réception du message : {{message.calling_date | moment-date-time}}</span>
        <span v-else class="missing_datas">Aucune date et heure de réception n'ont été renseignées.</span>
        <span> saisit par : {{message.creating_user.email}}</span>
      </div>

    </div>

    <div class="receiver col-md-3" v-if="origin == null">
      <strong>Client</strong> :
        <router-link :to="{ name: 'customer', params: { id: message.customer.id } }">
          <a class="btn-sm m-t-10" v-if="message.customer != null">{{message.customer.name}}</a>
        </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name:"Hotline_Item",
  props:["message","origin"],
  computed:{
    message_style(){
      let style = 'intermediary'

      style += this.origin ? " col-md-9" : " col-md-6"

      return style
    }
  },
}
</script>
<style scoped>

.item-container {
    display: flex;
    border:solid 1px lightgrey;
    margin-bottom:5px;
    background-color: white;
}

</style>



// WEBPACK FOOTER //
// client/components/Hotline/Item.vue